import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { IdInterface, ProductInterface } from '../data';
import { ProductProvider } from '../providers/product.provider';
import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';
import { ProductsbyOrderTypeInterface } from '../data/productsbyordertype.interface';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface GetProductsByOrderTypeUseCaseParams {
    portfolioCode: IdInterface,
    clientCode?: IdInterface,
    distributionChannel?: string[],
    orderType?: string ,
    riskLevel?: string
}
@Injectable()
export class GetProductsByOrderTypeUseCase implements UseCaseWithParam<GetProductsByOrderTypeUseCaseParams,Observable<Transaction<ProductInterface[]>>> {
    constructor(private productProvider: ProductProvider) {}

    bind(params:GetProductsByOrderTypeUseCaseParams): Observable<Transaction<ProductInterface[]>> {
        return this.productProvider.findByOrderType(params.portfolioCode,params.clientCode,
            params.distributionChannel,params.orderType,params.riskLevel).pipe(
            map((transaction) =>
                transaction.map(
                    (products) => Transaction.success(cloneDeep(products)),
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}

@Injectable()
export class GetProductsByOrderTypeClientUseCase implements UseCaseWithParam<GetProductsByOrderTypeUseCaseParams,Observable<Transaction<ProductInterface[]>>> {
    constructor(private productProvider: ProductProvider) {}

    bind(params:GetProductsByOrderTypeUseCaseParams): Observable<Transaction<ProductInterface[]>> {
        return this.productProvider.findByOrderTypeClient(params.portfolioCode,params.clientCode,
            params.distributionChannel,params.orderType,params.riskLevel).pipe(
            map((transaction) =>
                transaction.map(
                    (products) => Transaction.success(cloneDeep(products)),
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
